import { fetchApi } from './api';

// Transform API response to match UI expectations
const transformUserData = (usersData) => {
  if (!usersData || !usersData.data) return usersData || [];
  
  return usersData.data.map(user => ({
    id: user.id,
    number: user.number,
    phone: user.number, // Map number to phone for UI compatibility
    name: user.number || `User-${user.id}`, // Generate name from number or ID
    role: user.Role?.name || 'user',
    status: 'active', // Default status since API doesn't provide it
    is_test_account: user.is_test_account === true || user.is_test_account === 1 || user.is_test_account === 'true' || user.is_test_account === '1',
    createdAt: user.createdAt,
    updatedAt: user.updatedAt,
    deletedAt: user.deletedAt,
    roleId: user.roleId,
    originalData: user // Keep original data for reference
  }));
};

// Fetch all users
export const getUsers = async () => {
  const data = await fetchApi('/users', { method: 'GET' });
  // Transform the data to match UI expectations
  return {
    ...data,
    data: transformUserData(data)
  };
};

// Create new user
export const createUser = async (userData) => {
  return fetchApi('/users', {
    method: 'POST',
    body: userData,
  });
};

// Update existing user
export const updateUser = async (id, userData) => {
  return fetchApi(`/users/${id}`, {
    method: 'PUT',
    body: userData,
  });
};

// Delete user
export const deleteUser = async (id) => {
  return fetchApi(`/users/${id}`, {
    method: 'DELETE',
  });
};
